import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlmReconocimientoCardComponent } from './glm-reconocimiento-card.component';
import { GLMMaterialDesignModule } from '../material-design/material-design.module';
import { GlmBadgeModule } from '../glm-badge/glm-badge.module';
import { ReconcocimientoCardCategoriaComponent } from './reconcocimiento-card-categoria/reconcocimiento-card-categoria.component';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [GlmReconocimientoCardComponent, ReconcocimientoCardCategoriaComponent],
  imports: [
    CommonModule,
    GLMMaterialDesignModule,
    GlmBadgeModule,
    RouterModule
  ],
  exports: [GlmReconocimientoCardComponent]
})
export class GlmReconocimientoCardModule { }
